import React, {Fragment, useState, useEffect} from "react";

import {Row, Col} from "react-bootstrap";
import {useTranslation} from 'react-i18next';
import Cookies from 'js-cookie';
import {Checkmark} from 'react-checkmark';
import axios from "axios";
import OmantelVisaHeader from "./OmantelVisaHeader";
const { config } = require('../api/api')

function OmantelOrderSuccess({usrtok}) {
    const base_url = config.baseURL;
    const [userData, setUserData] = useState(false);

 
    const [order_id, setOrder] = useState('');

    // const [orderData, setOrderData] = useState(false);
    // useEffect(() => {
    //     // debugger;
    //     const storedOrderString = sessionStorage.getItem('orderResult');
    //     if (storedOrderString) {
    //         const storedOrder = JSON.parse(storedOrderString);
    //         setOrderData(storedOrder);
    //     }
    // }, []);


    // useEffect(() => {

    //     // debugger;

    //     const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
    //     if (storedUserString !== undefined) {
    //         const storedUser = JSON.parse(storedUserString);
    //         setUserData(storedUser);
    //     }
    // }, []);

    // usrtok = userData.access_token;
    // console.log(usrtok)
    const {t,i18n} = useTranslation(); 
    const [lnstr,setlnstr] = useState("en");
     useEffect(()=>{
              const getVisaDetails=sessionStorage.getItem("visaInfo");
            
              if(getVisaDetails){
                const parseVisaInfo=JSON.parse(getVisaDetails);
              if(parseVisaInfo?.locale){
              i18n.changeLanguage(parseVisaInfo?.locale)
              setlnstr(parseVisaInfo?.locale);
              }
              }
            },[])
        
        
             // Function to update HTML dir attribute based on language
              const updateHtmlDirAttribute = () => {
                document.documentElement.dir = i18n.dir(); // Set document direction
              };
            
              // Update HTML dir attribute when component mounts and language changes
              useEffect(() => {
                updateHtmlDirAttribute();
              }, [i18n.language]);
    

    const urlSearchString = window.location.search;

    const uparams = new URLSearchParams(urlSearchString);
   
//    setOrder(order);

    const [vendorKey, setVendorKey] = useState('');
    useEffect(()=>{
        const order =uparams.get('orderid');
        setOrder(order);
    },[]);

    useEffect(() => {

        const postvData = {organization_name: "Omantel"};

        if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


            fetch(base_url+'/create_organization', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postvData),
            })
                .then(response => response.json())
                .then(data => {

                    // console.log(data)
                    setVendorKey(data.result[0].vendor_key);
                    // debugger
                })
                .catch(error => {
                    console.error('Error posting data:', error);
                });


        }
    }, [vendorKey]); // Dependency array

    // console.log(vendorKey)


    const [OrderDetails, setOrderDetails] = useState('');
    const [OrderID, setOrderID] = useState('');
    const [CreatedDate, setCreatedDate] = useState('');
    const [PaymentStatus, setPaymentStatus] = useState('');
    const [OrderSts, setOrderSts] = useState('');
    const [ApplicationSts, setApplicationSts] = useState('');
    const [ApplicationID, setApplicationID] = useState('');
    const [ProcessingSts, setProcessingSts] = useState('');
    const [userDetails,setUserDetails]=useState(null);
    useEffect(() => {

        if (vendorKey !== '') {

            var GivenData = {
                'order_id': uparams.get('orderid'),
                'vendor_key': vendorKey
            }

            var vkData = GivenData;
            debugger

            fetch(base_url+'/omantel_order_details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(vkData),
            })
                .then(response => response.json())
                .then(data => {
                    debugger
                    console.log(data.result.order)

                    setOrderDetails(data.result.order)
                    setOrderID(data.result.order.id)
                    setCreatedDate(data.result.order.created_at)
                    setPaymentStatus(data.result.order.payment_status)
                    setOrderSts(data.result.order.order_status)
                    setApplicationSts(data.result.order.applications[0].application_status)
                    setApplicationID(data.result.order.applications[0].id)
                    setProcessingSts(data.result.order.applications[0].processing_status)

                })
                .catch(error => {
                    console.error('Error posting data:', error);
                });
        }
    }, [usrtok, vendorKey, uparams.get('order_id')]);

    useEffect(()=>{
      const visa_user=  sessionStorage.getItem("visaInfo");
      if(visa_user!==undefined){
        const parseUserDetails=JSON.parse(visa_user);
        setUserDetails(parseUserDetails);
      }
    },[])

    const handleBackBtn=()=>{
       const  href1=`/omantel-visa?email=${userDetails?.email}&firstname=${userDetails?.first_name}&lastname=${userDetails?.last_name}&locale=${userDetails?.locale}`;
       sessionStorage.removeItem("CountryFlags");
       sessionStorage.removeItem("VisaSearchResult");
       sessionStorage.removeItem("deeplink");
       sessionStorage.removeItem("event_data");
       sessionStorage.removeItem("order_data");
       sessionStorage.removeItem("userDataForVisa");
       sessionStorage.removeItem("visaFormDetails");
      const url_data =sessionStorage.getItem("visaInfo");
      if(url_data){
        const parseUrl=JSON.parse(url_data);
        const{destinationCountry,travelDate,passportCountry,...filteredData} =parseUrl;
        sessionStorage.setItem("visaInfo",JSON.stringify(filteredData));
      }

       window.location.href=href1;
    }


    return (
        <>
        <OmantelVisaHeader />
    
                <div className="container">
                <div style={{height:"80vh",alignContent:"center"}}>
                    <div className="row">

                        <Col md={3} className="text-center">
                        </Col>

                        <Col md={6} className="m-2 mt-4">

                            <Checkmark/>
                            <br/>
                            <h3 className="h3" style={{textAlign: 'center'}}>

                                {t('Order')} {t('Placed')} {t('Successfully')}

                            </h3>

                            {/*<p style={{textAlign: 'center'}}>Order No : <b>{uparams.get('order_id')}</b></p>*/}
                            <br/>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <tr>
                                    <td style={{textAlign: 'left', width: '30%', fontWeight: 'bold', padding: '8px'}}>
                                        {t("Order")} {t("ID")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{order_id}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("First")} {t("Name")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.first_name}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Last")} {t("Name")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.last_name}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Email")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.email}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Arrival")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.arrival}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Destination")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.destination}</b></td>
                                </tr>
                               
                            </table>
                          


                        </Col>

                        <Col md={12} className="text-center" style={{paddingTop:'40px'}}>
                        <p ><button style={{color:'green', textAlign:'right', fontWeight:'bold', paddingTop:'20px', fontSize:'22px',backgroundColor: "inherit"}} onClick={handleBackBtn}>{t("Back Home")}</button></p>
                        </Col>


                    </div>
</div>
                </div>         
        </>
    );
}

export default OmantelOrderSuccess;